<div class="w-full max-w-full p-4 lg:p-8 bg-white dark:bg-surface-1 min-h-full backdrop-blur-sm rounded-2xl">
  <!-- Header Section -->
  <div class="flex flex-col justify-between gap-6 mb-8">
    <div class="flex items-center justify-between" [ngClass]="{'w-full': _commonService.isPanelOpen(), 'w-auto': !_commonService.isPanelOpen()}">
      <h1 class="text-2xl font-bold text-slate-900 dark:text-white">
        Conversation History
      </h1>
    </div>

    <!-- Action Buttons/Filters Section -->
    <div class="flex flex-wrap items-center gap-3 w-auto">
      <!-- Date Picker -->
      <app-date-picker 
        (dateRangeChange)="onDateRangeChange($event)"
        [value]="datePickerValue()"
        variant="outline"
        [size]="isSmallScreen() ? 'sm' : 'md'"
        [showComparison]="false"
        [showGroupBy]="false"
        className="bg-white dark:bg-slate-800"
      ></app-date-picker>

      <app-dropdown
        [options]="productOptions()"
        [selectedValue]="selectedProduct()"
        selectionMode="single"
        placeholder="All Products"
        (selectionChange)="selectedProduct.set($event)"
        className="min-w-[160px]"
        [size]="isSmallScreen() ? 'sm' : 'md'"
        variant="outline"
        iconName="box"
        iconClass="text-purple-600 dark:text-purple-400"
        menuClass="!w-auto min-w-[200px]"
      ></app-dropdown>

      <app-dropdown
        [options]="customerOptions()"
        [searchable]="true"
        [searchPlaceholder]="'Search Customer'"
        [selectedValue]="selectedCustomer()"
        selectionMode="single"
        placeholder="All Customers"
        [remoteSearch]="true"
        [loading]="isCustomersLoading()"
        (selectionChange)="selectedCustomer.set($event)"
        (searchChange)="onCustomerSearch($event)"
        (scrolledToEnd)="onCustomerScrollEnd()"
        className="min-w-[160px] h-full"
        [size]="isSmallScreen() ? 'sm' : 'md'"
        variant="outline"
        iconName="users"
        iconClass="text-purple-600 dark:text-purple-400"
        menuClass="!w-auto min-w-[200px]"
      ></app-dropdown>
      <app-dropdown
        [options]="agentOptions()"
        [searchable]="true"
        [searchPlaceholder]="'Search Agent'"
        [selectedValue]="selectedAgent()"
        selectionMode="single"
        placeholder="All Agents"
        [remoteSearch]="true"
        [loading]="isAgentsLoading()"
        (selectionChange)="selectedAgent.set($event)"
        (searchChange)="onAgentSearch($event)"
        (scrolledToEnd)="onAgentScrollEnd()"
        className="min-w-[160px]"
        [size]="isSmallScreen() ? 'sm' : 'md'"
        variant="outline"
        iconName="headset"
        iconClass="text-purple-600 dark:text-purple-400"
        menuClass="!w-auto min-w-[200px]"
      ></app-dropdown>

      <!-- Search Bar -->
      <div class="relative min-w-[200px] flex-1 sm:flex-none lg:min-w-[240px]">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
          <app-icon-v2 name="search" size="18" />
        </div>
        <input
          type="text"
          [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)"
          placeholder="Search items..."
          class="w-full max-w-[240px] pl-10 pr-4 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 transition-all duration-200"
          [ngClass]="isSmallScreen() ? 'py-1' : 'py-2.5'"
        />
      </div>

      <!-- Filter Actions -->
      <div class="flex items-center gap-2">
        <button 
          (click)="applyFilters()"
          class="flex items-center gap-2 px-4 py-2.5 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-xl transition-all duration-200 shadow-sm active:scale-95 cursor-pointer"
          [ngClass]="{'py-1 text-sm': isSmallScreen()}"
        >
          Apply
        </button>
        <button 
          (click)="resetFilters()"
          class="flex items-center gap-2 px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 font-bold rounded-xl hover:bg-slate-50 dark:hover:bg-slate-700 transition-all duration-200 shadow-sm active:scale-95 cursor-pointer"
          [ngClass]="{'py-1 text-sm': isSmallScreen()}"
        >
          Clear
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <!-- @if (isLoading()) {
  <div class="flex items-center justify-center py-20">
    <div class="flex flex-col items-center gap-4">
      <div class="w-10 h-10 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></div>
      <span class="text-slate-500 font-medium">Loading conversation history...</span>
    </div>
  </div>
  } @else { -->
    <!-- Table Display -->
    <div class="bg-white dark:bg-slate-800 rounded-2xl overflow-hidden">
      <app-paginated-table
        [headers]="headers"
        [tableData]="callHistory()"
        [totalItems]="totalItems()"
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [serverSide]="true"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        [tableActionOptions]="tableActionOptions"
        (actionSelected)="onActionSelected($event)"
        headerClass="bg-slate-50/50 dark:bg-slate-900/50"
        tableWrapperClass="bg-transparent"
        className="min-h-[70vh] [@media(max-height:620px)]:min-h-[50vh]"
        [hidePaginationTopBorder]="true"
      ></app-paginated-table>
    </div>
  <!-- } -->
</div>

<ng-template #audioRecording>
  <div
    class="w-full sm:w-[420px] max-w-[calc(100vw-40px)] bg-white dark:bg-slate-900 rounded-[32px] shadow-[0_20px_60px_rgba(0,0,0,0.3)] border border-slate-100 dark:border-white/5 overflow-hidden animate-in fade-in slide-in-from-bottom-5 duration-300">

    <div class="px-7 pt-7 pb-5 flex items-start justify-between border-b border-slate-50 dark:border-white/5">
      <div class="flex items-center gap-4">
        <div
          class="w-11 h-11 shrink-0 rounded-2xl bg-purple-50 dark:bg-purple-900/20 flex items-center justify-center text-purple-600 dark:text-purple-400">
          <app-icon-v2 name="Headphones" [size]="22"></app-icon-v2>
        </div>
        <div>
          <h3 class="font-bold text-slate-800 dark:text-white text-[17px] leading-tight">{{
            activePlayingCall()?.productName || 'Call Recording' }}</h3>
          <div class="flex items-center gap-2 mt-1.5">
            <span class="text-[12px] font-semibold text-slate-400 dark:text-slate-500">{{ $safeNavigationMigration(activePlayingCall()?.lastDate) |
              date:'MMM d, yyyy • hh:mm a' }}</span>
            <span class="w-1 h-1 rounded-full bg-slate-200 dark:bg-slate-700"></span>
            <span class="text-[12px] font-bold text-purple-600 dark:text-purple-400">Google Meet</span>
          </div>
        </div>
      </div>
      <button mat-dialog-close
        class="flex p-1.5 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-lg text-slate-300 dark:text-slate-500 transition-colors">
        <app-icon-v2 name="X" [size]="20"></app-icon-v2>
      </button>
    </div>

    <div class="px-7 py-8">
      <div class="flex items-center gap-6">
        <button (click)="$event.stopPropagation(); togglePlay()"
          class="w-14 h-14 shrink-0 flex items-center justify-center rounded-2xl bg-[#A446FF] text-white shadow-lg shadow-purple-600/30 hover:bg-[#8A2BE2] active:scale-95 transition-all">
          <app-icon-v2 [name]="isPlaying() ? 'Pause' : 'Play'" [size]="24" customClass="fill-current"></app-icon-v2>
        </button>
        <div class="flex-1">
          <div
            class="flex items-center justify-between mb-2 text-[12px] font-bold tabular-nums text-slate-400 dark:text-slate-500 uppercase tracking-wider font-mono">
            <div class="flex items-center gap-1 text-purple-600 dark:text-purple-400">
              <span>{{ formatTime(currentTime()) }}</span>
              <span class="text-slate-300 dark:text-slate-600 px-0.5">/</span>
              <span>{{ formatTime(audioDuration()) }}</span>
            </div>
          </div>
          <div class="h-6 flex items-center relative group cursor-pointer" (click)="$event.stopPropagation(); seek($event)">
            <div class="flex-1 h-2 bg-slate-100 dark:bg-slate-800 rounded-full relative">
              <!-- Seeker Thumb -->
              <div class="absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-[#A446FF] bg-white rounded-full -ml-1.5 transition-all duration-300 z-10 shadow-sm"
                [style.left.%]="audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
              </div>
              <!-- Filled Track -->
              <div class="absolute inset-y-0 left-0 bg-[#A446FF] rounded-full transition-all duration-300"
                [style.width.%]="audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

